<script setup lang="ts">
// types
import type { BlockCardImpactProps } from '@ts-blocks/block-card-impact/interfaces'
// hooks
import { useBlockCardImpact } from '@hooks/blocks/block-card-impact.hook'
// helpers
import { STRAPI_IMAGE_SIZES } from '@helpers/strapi-media'
// components
import { AppImage } from '@UI/Images/AppImage'
import { CardIcon } from '@UI/Cards/CardIcon'

defineOptions({
  name: 'BlockCardImpact',
})

const props = defineProps<{
  block: BlockCardImpactProps
}>()

const {
  refImageAlt,
} = useBlockCardImpact({
  block: () => props.block,
})
</script>

<template>
  <CardIcon
    class="block-card-impact"
    layout="vertical"
    surface="gray"
    :title="block.title ?? ''"
    :description="block.description"
    :description-clamp="false"
  >
    <template #top>
      <AppImage
        v-if="block.image"
        class="block-card-impact__img"
        :media="block.image"
        :sizes="STRAPI_IMAGE_SIZES"
        :alt="refImageAlt"
      />
      <span
        v-else
        class="block-card-impact__img"
      />
    </template>
  </CardIcon>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockCardImpact.scss" />
